// Full-screen loader covering the reprice → book sequence on the Pay page.
// Earlier this only covered /book/; we now also use it during /reprice/, so it
// takes an explicit `steps` list with a per-step state.

import { KairaMark } from "./KairaMark";

interface Step {
  label: string;
  state: "done" | "active" | "pending";
}

interface Props {
  airlineLabel: string;
  steps: Step[];
}

export function BookingLoader({ airlineLabel, steps }: Props) {
  return (
    <div className="loader-overlay">
      <div className="loader-card">
        {/* The design's pulsing yellow circle with a spinner inside now wraps
            the Kaira mark — keeps the rhythm of the pulse animation while
            putting the brand front and centre at the most anxious moment. */}
        <div className="book-loader-icon book-loader-icon-kaira">
          <KairaMark size={64} />
        </div>
        <h2 style={{ fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em", lineHeight: 1.15, marginBottom: 8 }}>
          Locking in your <span className="serif">booking</span>...
        </h2>
        <p style={{ fontSize: 14, color: "var(--ink-3)", lineHeight: 1.5 }}>
          We're talking to {airlineLabel}. Stay on this tab — we'll redirect when it's done.
        </p>

        <div className="book-steps">
          {steps.map((s, i) => (
            <div key={i} className={`book-step ${s.state}`}>
              <span className="step-icon" />
              <span className="step-label">{s.label}</span>
            </div>
          ))}
        </div>

        <div className="book-reassure">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
          <span><b>If anything fails after charge</b>, we refund automatically. Your wallet is never stuck.</span>
        </div>
      </div>
    </div>
  );
}
